import { IconProps } from "@/types/types";

export default function Printer({ width = "24", height = "24" }: IconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7 2C6.44772 2 6 2.44772 6 3V7H5C3.34315 7 2 8.34315 2 10V17C2 18.1046 2.89543 19 4 19H6V21C6 21.5523 6.44772 22 7 22H17C17.5523 22 18 21.5523 18 21V19H20C21.1046 19 22 18.1046 22 17V10C22 8.34315 20.6569 7 19 7H18V3C18 2.44772 17.5523 2 17 2H7ZM15.5 7V4.5H8.5V7H15.5ZM15.5 16.5H8.5V19.5H15.5V16.5ZM17.375 13C18.1344 13 18.75 12.3844 18.75 11.625C18.75 10.8656 18.1344 10.25 17.375 10.25C16.6156 10.25 16 10.8656 16 11.625C16 12.3844 16.6156 13 17.375 13Z" fill="currentColor" />
        </svg>


    )
}

